<template>
  <div class="teacher sdiv dinline-block vtop fs14 tleft cpointer" @click="goRoute(item.id)">
    <div class="igs dinline-block ofhidden vtop tcenter">
      <img class="trans3" :src="item.photo" />
    </div>
    <div class="txt dinline-block pl10 pr10 vtop">
      <div class="nm fs20 fbold ofhidden mt40 mb15 lh10 prelative pl15">{{item.name}}</div>
      <div class="int fs14 tc9 lh16 ofhidden">
        {{info}}
      </div>
      <div class="btns mt20">
        <span class="zbtn zbtn-bblue br30">了解更多</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "teachers-item",
  data () {
    return {
      info:'',
    }
  },
  props: [
    'item',
  ],
  methods:{
    goRoute(id){
      let path = `/train/teachers/detail?id=${id}` 
      let routeData = this.$router.resolve({
          path
      })
      window.open(routeData.href, '_blank')
      //this.$router.push({path:'/train/teachers/detail',query:{id:id}})
    },
    updateMD(){
      this.info = this.item.intro.replace(/<.*?>|\&.*\;/ig, "");
    },
  },
  mounted() {
    this.updateMD();
  },
  updated() {
    this.updateMD();
  },
}
</script>

<style scoped>
  .teacher{width: 320px;height: 250px;background: #f2f4f3;background: linear-gradient(to right, #f2f4f3 0%, #f2f4f3 80%, #fff 100%);}
  .teacher:hover{background: #f9faf9;}
  .teacher .igs{width: 155px;height: 100%;position: relative;}
  .teacher img{position: absolute;left: 0;right: 0;top: 15px;margin: 0 auto;width: 95%;height: auto;}
  .teacher .txt{width: 160px;}
  .teacher .nm::before{content: '';position: absolute;left: 0;top: 2px;width: 4px;height: 22px;background: #147ad8;}
  .teacher .int{height: 90px;}
  .teacher .zbtn{padding: 5px 25px;}
</style>



// WEBPACK FOOTER //
// src/components/train/teachers-item.vue